export const ISO_DATE_FORMAT = 'YYYY-MM-DD' as const;

export const TOOLTIP_DATE_FORMAT = 'MMM DD, YYYY' as const;

export const DATE_FORMAT = 'YYYY/MM/DD' as const;

export const MILLISECONDS_PER_DAY = 86400000 as const;
